import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: "[radrQueryButtonGroup]" })
export class QueryButtonGroupDirective {
  constructor(public template: TemplateRef<any>) {}
}
